/* eslint-disable
    new-cap,
    no-var,
    radix,
    vars-on-top
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS202: Simplify dynamic range loops
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import Backbone from 'backbone';
import * as d3 from 'd3';
import $ from 'jquery';
import {debounce} from 'ts-debounce';
import _ from 'underscore';

import {getAdminAggregate, UsageAggregate} from 'useradmin/UserAdminDAO';
import UseRow from 'useradmin/UseRowTemplate';

class AdminAggregateView extends Backbone.View<Backbone.Model> {
  colorScale!: (val: number) => string;
  debouncedFetchForMonth!: () => void;
  month!: number;
  months!: Array<string>;
  year!: number;

  static initClass(): void {
    this.prototype.el = '#aggregate-activity';

    this.prototype.events = {
      // @ts-expect-error: Backbone events can be either the events hash or a method returning the events hash
      // The Backbone types do not know about this.
      'click .js-prev-month': 'requestPreviousMonth',
      'click .js-next-month': 'requestNextMonth',
      'click #toggle-aggregate': 'toggleAggregate',
    };
  }

  override initialize(): void {
    const current = new Date();
    this.year = current.getFullYear();
    this.month = current.getMonth();
    this.months = [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ];
    this.debouncedFetchForMonth = debounce(this.fetchForMonth.bind(this), 1000);
    this.colorScale = d3.interpolateRgb('#fff', '#69dd9a');
  }

  toggleAggregate(): void {
    // We don't fetch the aggregate activity because it frequently errors. To see if anyone is using it,
    // we hide it by default behind a toggle and only fetch the activity when the toggle is opened.
    // To unhide, remove class hidden and change arrow to point down. To hide, add class hidden and
    // change the arrow to point right.
    this.$('#toggle-aggregate').toggleClass('glyphicon-chevron-right');
    this.$('#toggle-aggregate').toggleClass('glyphicon-chevron-down');
    this.$('#aggregate-block').toggleClass('hidden');
    this.makeRequest();
  }

  requestPreviousMonth(): void {
    this.makeRequest(-1);
  }

  requestNextMonth(): void {
    this.makeRequest(1);
  }

  makeRequest(monthIncr?: number): void {
    if (monthIncr == null) {
      monthIncr = 0;
    }
    this.$('.centering-spinner-wrapper').removeClass('hidden');
    this.$('.spinner').removeClass('hidden');
    this.$('tbody').empty();
    this.$('.use-rows-title span').text('Click a cell on the calendar to show per-member stats.');
    this.month += monthIncr;
    if (this.month < 0) {
      this.year -= 1;
      this.month = 11;
    } else if (this.month === 12) {
      this.year += 1;
      this.month = 0;
    }
    this.$('.month').text(`${this.months[this.month]} ${this.year}`);
    this.debouncedFetchForMonth();
  }

  formatDate(dateStr: string): string {
    const [y, m, d] = Array.from(dateStr.split('-'));
    return `${m}/${d}/${y}`;
  }

  cellClickFn(
    result: UsageAggregate,
    dateStr: string
  ): (result: UsageAggregate, dateStr: string, ref: this) => void {
    return ((result, dateStr, ref) =>
      function () {
        ref.$('.use-rows tbody').empty();
        const sorted = _.sortBy(result.users, (user) => user.write + user.read);
        for (const user of Array.from(sorted)) {
          ref.$('.use-rows tbody').append(UseRow(user));
        }
        const u = result.users.length === 1 ? 'member' : 'members';
        return ref.$('.use-rows-title span').text(`${dateStr}: ${result.users.length} active ${u}`);
      })(result, dateStr, this);
  }

  fetchForMonth(): void {
    getAdminAggregate({year: this.year, month: this.month + 1}).done(
      (res: {days: Array<UsageAggregate>; weeks: Array<UsageAggregate>; max_users: number}) => {
        this.$('.centering-spinner-wrapper').addClass('hidden');
        this.$('.spinner').addClass('hidden');
        let before = true;
        let after = false;
        return (() => {
          const result1 = [];
          for (let week = 0; week < res.days.length / 7; week++) {
            var $col;
            var result;
            const $row = $('<tr>');
            this.$('.calendar tbody').append($row);
            for (let day = 0; day < 7; day++) {
              $col = $('<td>');
              result = res.days[week * 7 + day];
              const dateNum = parseInt(result.date.split('-')[2]);
              if (!before && dateNum === 1) {
                after = true;
              }
              if (dateNum === 1) {
                before = false;
              }
              $col.text(dateNum);
              if (before || after) {
                $col.css('color', '#aaa');
              }
              $row.append($col);
              $col.click(this.cellClickFn(result, this.formatDate(result.date)));
              const color = this.colorScale(Math.min(result.users.length / res.max_users, 1));
              $col.css('background-color', color);
            }

            result = res.weeks[week];
            $col = $('<td>');
            $col.text(result.users.length).css('font-weight', 600);
            $col.click(this.cellClickFn(result, `Week of ${this.formatDate(result.date)}`));
            result1.push($row.append($col));
          }
          return result1;
        })();
      }
    );
  }
}
AdminAggregateView.initClass();

export default AdminAggregateView;
